export const adminUsers = [
    {
        "nomComplet": "Hamadoun Sankaré",
        "adresse": "Golf",
        "email": "hams@yopmail.com",
        "telephone": "+22378694512",
        "role": "administrateur principal",
        "permissions": "tout droits",
        "Etat": "actif"
    },
    {
        "nomComplet": "Ibrahima KONE",
        "adresse": "Niamana",
        "email": "ib@yopmail.com",
        "telephone": "+22178965412",
        "role": "administrateur secondaire",
        "permissions": "Gestion des abonnées",
        "Etat": "actif"
    },

    {
        "nomComplet": "Paul Diassana",
        "adresse": "Cité Unicef",
        "email": "paul@yopmail.com",
        "telephone": "+22178965412",
        "role": "administrateur secondaire",
        "permissions": "Gestion des abonnées",
        "Etat": "inactif"
    },

]